export * from "-!../../../../node_modules/style-loader/index.js!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResultPeriodical.vue?vue&type=style&index=0&id=69126128&lang=scss&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/service/ResultPeriodical.vue?vue&type=style&index=0&id=69126128&lang=scss&scoped=true&
// module id = F/nk
// module chunks = 0